import React from 'react';

const PATHS = {
  'arrow-left': <path d="M15 6l-6 6 6 6" />,
  'logout': <><path d="M9 5H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></>,
  'chevron-right': <path d="M9 6l6 6-6 6" />,
  'search': <><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>,
  'eye': <><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></>,
  'edit': <><path d="M4 20h4L19 9a2 2 0 0 0-3-3L5 17v3z" /><path d="M14 6l3 3" /></>,
  'package': <><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" /><path d="M4 7.5l8 4.5 8-4.5" /><path d="M12 12v9" /></>,
  'check': <path d="M5 12l4 4 10-10" />,
  'x': <path d="M6 6l12 12M18 6L6 18" />,
  'user': <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></>,
  'rotate': <><path d="M20 11a8 8 0 1 0-1 5" /><path d="M20 5v6h-6" /></>,
  'send': <><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4 20-7z" /></>,
  'plus': <path d="M12 5v14M5 12h14" />,
  'trash': <><path d="M4 7h16" /><path d="M9 7V4h6v3" /><path d="M6 7l1 13h10l1-13" /></>,
  'link': <><path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1" /></>,
  'photo': <><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="8.5" cy="10" r="1.5" /><path d="M21 16l-5-5-7 7" /></>,
  'message': <path d="M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-5 4V6a1 1 0 0 1 1-1z" />,
  'users': <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-5 6-5s6 1.7 6 5" /><path d="M16 5.5a3 3 0 0 1 0 5.5" /><path d="M21 20c0-2.2-1.3-3.7-3.3-4.4" /></>,
  'phone': <path d="M5 4h3l2 5-2 1a11 11 0 0 0 5 5l1-2 5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />,
  'list': <><path d="M8 6h13" /><path d="M8 12h13" /><path d="M8 18h13" /><path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></>,
  'microphone': <><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0" /><path d="M12 18v3" /></>,
  'dollar': <><path d="M12 3v18" /><path d="M16 7.5a3.5 3.5 0 0 0-3.5-2.5h-1a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-1A3.5 3.5 0 0 1 8 16.5" /></>,
  'shield': <path d="M12 3l8 3v6c0 4.5-3.2 7.3-8 9-4.8-1.7-8-4.5-8-9V6l8-3z" />,
};

export default function Icon({ name, size = 20, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      {PATHS[name]}
    </svg>
  );
}
